import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TicketGroupFilterSelectionUrgencyService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/tm/ticketGroupFilterSelectionUrgencys')
  }

  public getLinkedAttribute(objectType: string) : string {
    return 'ticketGroupFilter';
  }
}